import { BEGINNER, EASY, IMPOSSIBLE } from '../../../data/constants/difficulty';

export const adaptSkillToDifficulty = (difficulty: number) => (
  skillLevel: number,
): number => {
  if (difficulty === BEGINNER || difficulty === EASY) return skillLevel + 1;
  if (difficulty === IMPOSSIBLE) return Math.max(1, skillLevel - 1);
  return skillLevel;
};
